<template>
  <v-skeleton-loader
      class="mx-auto text-center"
      type="image"
  ></v-skeleton-loader>
</template>

<script>
export default {
  name: "RegularLoader",
}
</script>

<style scoped>

</style>